var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"top"}},[(_vm.$route.meta.nav)?_c('app-nav'):_vm._e(),(_vm.$route.meta.social)?_c('SocialSharing'):_vm._e(),_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }